import { render } from "./AddressItem.vue?vue&type=template&id=358bdbf8&scoped=true"
import script from "./AddressItem.vue?vue&type=script&lang=js"
export * from "./AddressItem.vue?vue&type=script&lang=js"

import "./AddressItem.vue?vue&type=style&index=0&id=358bdbf8&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358bdbf8"]])

export default __exports__